import { GridcoTitle } from "../components";
import { GridcoDashboardItem, TabSwitcher } from "../Gridco_Das";
import { ReactComponent as BankingAalytics } from "../../../icons/dashboard/bankingAnalytics.svg";
import Hamburger from "../../../components/Hamburger";

export function Automation() {
  return (
    <div className="w-full">
      <div className="dashboard-header flex items-center justify-between px-4">
        <Hamburger />
        <div className="ms-5">
          <TabSwitcher />
        </div>
        <div className="flex-1 flex justify-center">
          <GridcoTitle />
        </div>
      </div>
      <div className="dashboard-item-container">
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-row flex-wrap gap-5 justify-center">
            <GridcoDashboardItem
              Icon={BankingAalytics}
              title="Bid Automation"
              to="bid-automation"
            />
            <GridcoDashboardItem
              Icon={BankingAalytics}
              title="DAM Performance Analysis"
              to="dam-performance"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
